(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.visTabs = {
    attach: function (context, settings) {
      $(once('visTabs','.tabs__container', context)).each(function () {

        // @TODO: This is using a mixture of jQuery and Vanilla JS which is confusing.
        // Fix this up to use just one or the other.
        const radioButtons = $(this).children('input[type="radio"]');

        // Add event listener to each radio button.
        radioButtons.each(function() {
          // Get the child of the radio button.
          const childId = $(this).attr('id') + '-content';

          // The tab container parent.
          const parent = $(this).parents('.tabs__container');

          // The child element (ie the "id" of the radio).
          const child = parent.find('#' + childId);

          // Calculate the height of the active child.
          const childHeight = child.outerHeight();

          // Add a data attribute we can use later.
          $(this).data('child-height', childHeight);

          // Set the wrapper height on initial load.
          setWrapperHeight(this);

          // Whenever a radio changes, it should reset the wrapper height.
          $(this).on('change', function() {
            // Get the corresponding child element.
            setWrapperHeight(this);
            // Scroll the tab container into view and scroll the labels.
            if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
              const parentEl = this.parentElement.parentElement;
              scrollElementIntoView(parentEl, this);
            }
          });

          const outerThis = $(this);

          // When turning a device or resizing the window the heights should recalculate.
          $(window).on('resize', function() {
            const child = parent.find('#' + childId);
            // Calculate the height of the active child
            const childHeight = child.outerHeight();
            $(outerThis).data('child-height', childHeight);
            setWrapperHeight(outerThis);
          });

        });

        // Add swipe functionality on touch devices.
        if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
          var startX;
          var startY;
          var currentTab = 0;
          var tabCount = this.querySelectorAll('input[type="radio"]').length;
          var tabContentsWrapper = this.querySelector('.tab_contents__wrapper');

          tabContentsWrapper.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          });

          tabContentsWrapper.addEventListener('touchend', function (e) {
            var endX = e.changedTouches[0].clientX;
            var endY = e.changedTouches[0].clientY;
            var deltaX = endX - startX;
            var deltaY = endY - startY;
            const parentEl = this.parentElement;

            if (Math.abs(deltaX) > Math.abs(deltaY)) {
              if (deltaX > 50 && currentTab > 0) {
                currentTab--; // Swipe right, move to the previous tab.
              } else if (deltaX < -50 && currentTab < tabCount - 1) {
                currentTab++; // Swipe left, move to the next tab.
              }

              // Get the next radio input.
              var radioInput = parentEl.querySelector('input[type="radio"]:nth-child(' + (currentTab + 1) + ')');
              radioInput.checked = true;

              // Scroll the tab container into view and scroll the labels.
              scrollElementIntoView(parentEl, radioInput);

              // Reset the wrapper height as the onchange event is not triggered.
              setWrapperHeight(radioInput);
            }
          });

          /**
           * Scrolls the tab container into view and scrolls the labels at the top.
           *
           * @param {Object} element The tab container.
           * @param {Object} radioInput The radio input selected.
           */
          function scrollElementIntoView(element, radioInput) {
            element.scrollIntoView({ behavior: 'auto', block: 'start' });
            var checkElementInViewport = function(element) {
              var rect = element.getBoundingClientRect();
              var inViewport = (
                rect.top >= 0 &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight)
              );
              if (inViewport) {
                clearInterval(intervalId);
                // Scroll the labels at the top when we check a new radio.
                var labelForCheckedRadio = element.querySelector('label[for="' + radioInput.id + '"]');
                var labelContainer = element.querySelector('.tab_headings__container');
                var labelPosition = labelForCheckedRadio.getBoundingClientRect().left;
                var containerPosition = labelContainer.getBoundingClientRect().left;
                var scrollAmount = labelPosition - containerPosition;

                // Scroll the label container to the selected label.
                labelContainer.scrollTo({
                  left: labelContainer.scrollLeft + scrollAmount,
                  behavior: 'auto'
                });
              }
            }
            // Run the function periodically.
            var timesRun = 0;
            var intervalId = setInterval(function() {
              // Clear this check if it has run too many times.
              timesRun += 1;
              if(timesRun === 60) {
                clearInterval(intervalId);
              }
              // Check whether the top of the tab container is in the viewport then move the labels.
              checkElementInViewport(element);
            }, 500); // Run every 1000 milliseconds (1 second)
          };

          /**
           * Sets the wrapper height based on the radio checked.
           *
           * @param {Object} radio The radio element..
           */
          function setWrapperHeight(radio) {
            // Get the corresponding child element.
            if ($(radio).is(':checked') === true) {
              const wrapper = $(radio).siblings('.tab_contents__wrapper');
              const height = $(radio).data('child-height') + 'px';
              wrapper.height(height);
            }
          }
        }

      });
    }
  }
}(jQuery, Drupal, once));
